import { IconEnum } from './types'

export const validateIconType = (value?: string): IconEnum | undefined => {
    const iconString = IconEnum[value as keyof typeof IconEnum]
    return iconString
}
